import { Group, Radio } from '@mantine/core';
import { useFinancialsStore } from '../../../../store/financials-store/financials-store';
import { setViewBy } from '../../../../store/financials-store/financials-store.actions';
import { ChartType } from '../../../../store/financials-store/financials-store.type';
import { newCOLORS } from '../../../../styles/colors';
import { baseBlack, inkBase, secondaryLight } from '../../../../styles/design-tokens';
import { Button } from '../../../../ui-library/button/button';
import { Icon } from '../../../../ui-library/icon/icon';

function ChartDisplayTypeButtonSet({
  onSetLineChart,
  onSetBarChart,
  selectedChartType,
  onExportChart,
  showSelectViewBy,
}: {
  onSetLineChart: () => void;
  onSetBarChart: () => void;
  selectedChartType: ChartType;
  onExportChart: () => Promise<void>;
  showSelectViewBy?: boolean;
}) {
  const viewBy = useFinancialsStore((state) => state.viewBy);
  return (
    <Group mb={12} justify="space-between">
      <Group>
        <StyledButton
          label="Pie Chart"
          iconName="pie_chart"
          onClick={onSetLineChart}
          selected={selectedChartType === ChartType.Pie}
        />
        <StyledButton
          label="Bar Chart"
          iconName="bar_chart"
          onClick={onSetBarChart}
          selected={selectedChartType === ChartType.Bar}
        />
      </Group>
      <Group>
        {showSelectViewBy && (
          <Radio.Group
            onChange={(value) => setViewBy(value as 'points' | 'tasks')}
            value={viewBy}
            styles={{ label: { fontWeight: 600, marginLeft: '30px' } }}
          >
            <Group>
              <Radio
                value="tasks"
                label="Tasks"
                variant="outline"
                color={secondaryLight}
                styles={{
                  radio: { cursor: 'pointer' },
                  label: { fontWeight: 550, color: viewBy === 'tasks' ? baseBlack : inkBase },
                }}
              />
              <Radio
                value="points"
                label="Points"
                variant="outline"
                color={secondaryLight}
                styles={{
                  radio: { cursor: 'pointer' },
                  label: { fontWeight: 550, color: viewBy === 'points' ? baseBlack : inkBase },
                }}
              />
            </Group>
          </Radio.Group>
        )}
        <StyledButton label="Export" iconName="download" onClick={onExportChart} selected={true} />
      </Group>
    </Group>
  );
}

function StyledButton({
  label,
  iconName,
  onClick,
  selected,
}: { label: string; iconName: string; onClick: () => void; selected: boolean }) {
  return (
    <Button
      variant={selected ? 'secondary' : 'outline'}
      radius="xl"
      size="sm"
      leftSection={
        <Icon
          name={iconName}
          color={selected ? newCOLORS.white : newCOLORS.gray}
          size={16}
          style={{ cursor: 'pointer' }}
        />
      }
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

export { ChartDisplayTypeButtonSet };
